import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { DomainManagerService } from './service/domain-manager.service';
import { SidebarStateService } from './service/sidebar-state.service';
import { SessionTimerService } from './service/session-timer.service';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'Admin';
  data: any = false;
  domain: string = window.location.hostname;
  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly titleService: Title,
    private readonly domainService: DomainManagerService,
    public readonly sidebarState: SidebarStateService,
    private readonly sessionTimer: SessionTimerService
  ) { }

  ngOnInit(): void {
    // Resumes the session-expiry warning/logout schedule from the stored token's
    // own `exp` claim on a full page reload; a no-op when no token is present.
    this.sessionTimer.start();

    let faviconPath: string;

    if (this.domainService.isRadiologyDomain) {
      faviconPath = "./assets/image/radiology-favicon.ico";
      this.titleService.setTitle("Plus Radiology");
    } else if (this.domainService.isDoctorDomain) {
      faviconPath = "./assets/image/Plus-Doctor-favicon.ico";
      this.titleService.setTitle("Plus Doctor");
    } else if (this.domainService.isPediatricDomain) {
      faviconPath = "./assets/image/plus_pedia_logo.png";
      this.titleService.setTitle("Plus Pediatric");
    } else if (this.domainService.isGynecologistDomain) {
      faviconPath = "./assets/image/plus_gynecologist_logo.png";
      this.titleService.setTitle("Plus Gynecologist");
    } else {
      faviconPath = "./assets/image/favicon.ico";
      this.titleService.setTitle("Plus Physio");
    }
    this.setFavicon(faviconPath);

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      takeUntil(this.destroy$)
    ).subscribe(() => {
      this.data = !this.activatedRoute.snapshot.firstChild?.routeConfig?.path?.startsWith('login') &&
        !this.activatedRoute.snapshot.firstChild?.routeConfig?.path?.startsWith('register');
    });
  }

  setFavicon(faviconUrl: string): void {
    let link: HTMLLinkElement | null =
      document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.getElementsByTagName("head")[0].appendChild(link);
    }
    link.href = faviconUrl;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
